import { FileText } from 'lucide-react';
import { Button, openFilePreview } from '@proerp/ui';

/**
 * Bericht als PDF **ansehen** (ADR 0085, umgestellt 2026-08-10 nach ADR 0075).
 *
 * Vorher lud der Knopf die Datei herunter. Das war für einen kurzen Blick der
 * falsche Weg: In Safari zeigt eine `blob:`-URL gar kein PDF, und sonst liegt
 * nach jedem Klick eine Datei mehr im Download-Ordner. Jetzt öffnet der Knopf
 * die Vorschau; „Herunterladen" steht darin.
 *
 * Ein Knopf, kein Anker: Es wechselt keine Seite (CLAUDE.md §9 verlangt Anker
 * nur für Seiten*sprünge*), und der Abruf braucht das Token aus dem
 * localStorage — ein `<a href>` trüge es nicht und liefe in ein 403.
 */
export function ReportPreviewButton({
  path,
  filename,
  title,
  label = 'Bericht (PDF)',
}: {
  path: string;
  filename: string;
  /** Kopfzeile der Vorschau, z. B. „Bedarfsvorschau". */
  title: string;
  label?: string;
}) {
  return (
    <Button
      type="button"
      variant="primary"
      onClick={() => openFilePreview({ path, title, filename, mimeType: 'application/pdf' })}
    >
      <FileText className="size-4" aria-hidden />
      {label}
    </Button>
  );
}
